var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LightningIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.011 5.64639L7.12723 12.5H10.0028C10.5537 12.5 11 12.9491 10.9998 13.4985L10.9976 18.3472L16.8893 11.5H14.0018C13.4486 11.5 13.001 11.0504 13.0021 10.5004L13.011 5.64639ZM15.0002 9.49999H19.2316C20.3357 9.49999 20.649 10.1772 19.9276 11.0171L10.9551 21.463C9.87544 22.7199 9.00021 22.3993 9.00021 20.7366V14.5H4.76882C3.66475 14.5 3.35141 13.8228 4.07281 12.9829L13.0453 2.53697C14.125 1.28003 15.0002 1.60064 15.0002 3.26339V9.49999Z",
    fill: ""
  }));
}
export var LightningIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: LightningIconInner
  }, props));
};